import { __awaiter } from '../../../_virtual/_tslib.js';
import { useContainer } from '@hub-la/fe-container';
import { HttpClient } from '@hub-la/fe-core-http-client';
import { useQuery } from 'react-query';
import { GetMembersArea } from '../../usecases/get-members-area.js';

const useGetMembersArea = input => {
  const container = useContainer();
  return useQuery(['get-members-area', input.productId], () => new GetMembersArea(container.get(HttpClient)).execute(input), {
    initialData: {},
    enabled: true,
    cacheTime: Infinity,
    refetchOnWindowFocus: false,
    retry: 3,
    retryDelay: 1000,
    onSuccess: data => __awaiter(void 0, void 0, void 0, function* () {
      return data;
    })
  });
};

export { useGetMembersArea };
